// src/pages/Home.js

import React from 'react';
import '../styles/homeStyles.css';
import DesktopPromo from '../assets/Videos/Channel_Promo/Goal-Header-Desktop.mp4';
import MobilePromo from '../assets/Videos/Channel_Promo/Goal-Header-Mobile.mp4';
import NewsletterSection from './Newsletter';
import RogersLogo from '../assets/Logos/Channel-Rogers.webp';
import XfinityLogo from '../assets/Logos/Channel-Rogers-Xfinity.webp';
import InfinitePosterMarquee from './InfinitePosterMarquee';
import MosaicExplodeGrid from './MosaicExplodeGrid';

const Home = () => {
  return (
    <main className="home">
      {/* Video Promotion Section */}
      <section className="video-promo">
        <div className="video-container">
        <video autoPlay loop muted playsInline className="promo-video desktop-promo">
          <source src={DesktopPromo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <video autoPlay loop muted playsInline className="promo-video mobile-promo">
          <source src={MobilePromo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        </div>
      </section>
      {/* Intro Section */}
      <section className="page-content" id="intro-section">
      <h2 id="we-speak-soccer-title">WE SPEAK SOCCER</h2>
        <h2 className="section-title">Where To Watch</h2>
        <div className="channel-grid">
          <div className="channel-card">
            <a href="https://www.rogers.com" target="_blank" rel="noopener noreferrer">
              <img src={RogersLogo} alt="Rogers Logo" className="channel-logo" />
            </a>
            <div className="channel-info">Channel<br className='mobile-break'></br> 425</div>
          </div>
          <div className="channel-card">
            <a href="https://www.rogers.com/xfinity" target="_blank" rel="noopener noreferrer">
              <img src={XfinityLogo} alt="Xfinity Logo" className="channel-logo" />
            </a>
            <div className="channel-info">Channels<br className='mobile-break'></br> 238 · 554 · 657</div>
          </div>
        </div>
      </section>
      <section className="page-content" id="programing-section">
        <h2 className="section-title">Series, Films, Documentaries, Original Content</h2>
        <div className="section-content">
          <MosaicExplodeGrid/>
        </div>
      </section>
      {/* Goal Newsletter Section */}
      <NewsletterSection/>
    </main>
  );
};

export default Home;
